import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-more-button',
  templateUrl: './more-button.component.html',
  styleUrls: ['./more-button.component.scss'],
  standalone: true,
  imports: [MatMenuModule, MatFormFieldModule, MatIcon, TranslateModule, MatMenuModule, MatButtonModule],
})
export class MoreButtonComponent {
  @Input() buttons;
  @Output() toggleEventCompleted = new EventEmitter<boolean>();
  constructor() {}

  isHidden(button) {
    if (typeof button.isHidden === 'function') {
      return button.isHidden(button.data);
    } else {
      return false;
    }
  }
}
